function computeOptions(options) {
  const hasGroupedOptions = options.some(opt => opt.optGroupLabel && opt.options);
  let optionsToUse = options;
  if (hasGroupedOptions) {
    optionsToUse = options.flatMap(currentGroup => [
      { optGroupLabel: currentGroup.optGroupLabel },
      ...currentGroup.options
    ]);
  }

  return {
    grouped: hasGroupedOptions,
    options: optionsToUse
  };
}

export default computeOptions;
